// extracted by mini-css-extract-plugin
module.exports = {"container":"Pop_container__pMLk9","tooltip":"Pop_tooltip__3jiwa"};